const ERROR_TYPE = 'network-error';

type TNetworkError = {
  type: typeof ERROR_TYPE;
  code: string;
  message: string;
  where: string;
  reason?: string;
};

type TApiErrorDetails = {
  reason?: unknown;
};

type TThrownError = Error & {
  where?: string;
  detail?: string;
  reason?: string;
};

type TApiErrorResponse = {
  success?: boolean;
  error?: string;
  message?: string;
  details?: unknown;
};

const ERROR_CODES = {
  network: 'NETWORK',
  unknown: 'UNKNOWN',
  unauthorized: 'unauthorized',
  forbidden: 'forbidden',
} as const;

export type {
  TNetworkError,
  TApiErrorDetails,
  TApiErrorResponse,
  TThrownError,
};
export {
  ERROR_TYPE,
  ERROR_CODES,
};
